import { InitialState } from './types'
import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'

const initialState: InitialState = {
  block: null,
  links: [],
  videos: [],
  processIsFetchingBlock: false,
  processIsFetchingLinks: false,
  processIsFetchingVideos: false,
  processIsCreateLink: false,
  processIsCreateVideo: false,
  processIsAssignLinksToBlock: false,
  processIsAssignFilesToBlock: false,
  processIsAssignVideosToBlock: false,
  processIsAssignGalleryToBlock: false,
  processIsUploadFiles: false,
  lastUploadedFiles: [],
  lastAddedLinkId: '',
  error: '',
}

export default handleActions(
  {
    [actions.fetchBlock]: state => {
      return {
        ...state,
        processIsFetchingBlock: true,
      }
    },
    [actions.fetchBlockSuccess]: (state, action) => {
      return {
        ...state,
        block: action.result,
        processIsFetchingBlock: false,
      }
    },
    [actions.fetchBlockFailure]: (state, action) => {
      return {
        ...state,
        processIsFetchingBlock: false,
        error: action.error,
      }
    },
    [actions.fetchLinks]: state => {
      return {
        ...state,
        processIsFetchingLinks: true,
      }
    },
    [actions.fetchLinksSuccess]: (state, action) => {
      return {
        ...state,
        links: action.result,
        processIsFetchingLinks: false,
      }
    },
    [actions.fetchLinksFailure]: (state, action) => {
      return {
        ...state,
        processIsFetchingLinks: false,
        error: action.error,
      }
    },
    [actions.createLink]: state => {
      return {
        ...state,
        processIsCreateLink: true,
      }
    },
    [actions.createLinkSuccess]: state => {
      return {
        ...state,
        processIsCreateLink: false,
      }
    },
    [actions.createLinkFailure]: (state, action) => {
      return {
        ...state,
        processIsCreateLink: false,
        error: action.error,
      }
    },
    [actions.assignLinksToBlock]: state => {
      return {
        ...state,
        processIsAssignLinksToBlock: true,
      }
    },
    [actions.assignLinksToBlockSuccess]: state => {
      return {
        ...state,
        processIsAssignLinksToBlock: false,
      }
    },
    [actions.assignLinksToBlockFailure]: (state, action) => {
      return {
        ...state,
        processIsAssignLinksToBlock: false,
        error: action.error,
      }
    },
    [actions.uploadFiles]: state => {
      return {
        ...state,
        processIsUploadFiles: true,
      }
    },
    [actions.uploadFilesSuccess]: (state, action) => {
      return {
        ...state,
        lastUploadedFiles: action.result,
        processIsUploadFiles: false,
      }
    },
    [actions.uploadFilesFailure]: (state, action) => {
      return {
        ...state,
        processIsUploadFiles: false,
        error: action.error,
      }
    },
    [actions.uploadedFilesDestroy]: state => {
      return {
        ...state,
        lastUploadedFiles: initialState.lastUploadedFiles,
      }
    },
    [actions.assignFilesToBlock]: state => {
      return {
        ...state,
        processIsAssignFilesToBlock: true,
      }
    },
    [actions.assignFilesToBlockSuccess]: state => {
      return {
        ...state,
        processIsAssignFilesToBlock: false,
      }
    },
    [actions.assignFilesToBlockFailure]: (state, action) => {
      return {
        ...state,
        processIsAssignFilesToBlock: false,
        error: action.error,
      }
    },
    [actions.fetchVideos]: state => {
      return {
        ...state,
        processIsFetchingVideos: true,
      }
    },
    [actions.fetchVideosSuccess]: (state, action) => {
      return {
        ...state,
        videos: action.result,
        processIsFetchingVideos: false,
      }
    },
    [actions.fetchVideosFailure]: (state, action) => {
      return {
        ...state,
        processIsFetchingVideos: false,
        error: action.error,
      }
    },
    [actions.createVideo]: state => {
      return {
        ...state,
        processIsCreateVideo: true,
      }
    },
    [actions.createVideoSuccess]: state => {
      return {
        ...state,
        processIsCreateVideo: false,
      }
    },
    [actions.createVideoFailure]: (state, action) => {
      return {
        ...state,
        processIsCreateVideo: false,
        error: action.error,
      }
    },
    [actions.assignVideosToBlock]: state => {
      return {
        ...state,
        processIsAssignVideosToBlock: true,
      }
    },
    [actions.assignVideosToBlockSuccess]: state => {
      return {
        ...state,
        processIsAssignVideosToBlock: false,
      }
    },
    [actions.assignVideosToBlockFailure]: (state, action) => {
      return {
        ...state,
        processIsAssignVideosToBlock: false,
        error: action.error,
      }
    },
    [actions.assignGalleryToBlock]: state => {
      return {
        ...state,
        processIsAssignGalleryToBlock: true,
      }
    },
    [actions.assignGalleryToBlockSuccess]: state => {
      return {
        ...state,
        processIsAssignGalleryToBlock: false,
      }
    },
    [actions.assignGalleryToBlockFailure]: (state, action) => {
      return {
        ...state,
        processIsAssignGalleryToBlock: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
